import { render, staticRenderFns } from "./membercard.vue?vue&type=template&id=af31e846"
import script from "./membercard.vue?vue&type=script&lang=js"
export * from "./membercard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports